import { gql } from '@apollo/client';

export default gql`
  query businessAccount($accountNumber: String!, $postcode: String!) {
    businessAccount(accountNumber: $accountNumber, postcode: $postcode) {
      accountNumber
      companyName
      phoneNumber
      active
      status
      formattedAddress
    }
  }
`;
